import React, { memo, useCallback, useMemo } from 'react';
// @ts-ignore
import { LineEchart as BarLineEchart } from '@gp/components/CustomEchart';
import { getEChartOpt, tootipFormatter } from './utils/common';
import {
  getFormatNumPlus,
  getFormatPercentPlus,
  getArraySort,
} from '@gp/utils/common';
import './index.scss';

interface BarAndLineEchartProps {
  data: IStudioOverallFinanceForecastCardResultItem;
  [keyName: string]: any;
}

function BarAndLineEchart(props: BarAndLineEchartProps) {
  const { data } = props;

  const getYAxisLeftMaxText = useCallback((v: any) => {
    const res = getFormatNumPlus(v, 2, false);
    return res;
  }, []);
  const getYAxisRightMaxText = useCallback((v: any) => {
    const res = getFormatPercentPlus(v);
    return res;
  }, []);

  const options = useMemo(() => {
    const opt = getEChartOpt(
      // echarts显示固定按日期升序，且排序时浅拷贝一层，不要影响到表格的数据展示
      getArraySort(
        Array.isArray(data) ? [...data] : [],
        'number',
        'asc',
        'date',
      ),
      getYAxisLeftMaxText,
      getYAxisRightMaxText,
    );
    return {
      ...opt,
      tooltip: {
        ...opt?.tooltip,
        formatter: tootipFormatter,
      },
    };
  }, [data]);

  return (
    <section className="dbg-studio-overall-finance-year-forecast-scenario-card-body">
      <BarLineEchart
        options={options}
        // xAxisData={}
        fontSize={12}
        style={{
          height: '350px',
          width: '100%',
          marginTop: 10,
          marginBottom: 0,
        }}
      />
    </section>
  );
}

BarAndLineEchart.defaultProps = {
  data: null,
};

export default memo(BarAndLineEchart);
